
exports.install = function (Vue, options) {
    // 删除提示
    Vue.prototype.conFirm = function (text,then,error) {
        return this.$confirm(text, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(res =>{
            return then()
        }).catch(err => {
            return error()
        });
    };
    // 日期格式
    Vue.prototype.dateFormat = function() {
        var date = new Date();
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        return y + '-' + m + '-' + d;
    };
    // 转日期格式
    Vue.prototype.dateFtt = function(fmt,date){ 
        var o = {   
            "M+" : date.getMonth()+1,                 //月份   
            "d+" : date.getDate(),                    //日
            "h+" : date.getHours(),                   //小时   
            "m+" : date.getMinutes(),                 //分   
            "s+" : date.getSeconds(),                 //秒   
            "q+" : Math.floor((date.getMonth()+3)/3), //季度   
            "S"  : date.getMilliseconds()             //毫秒   
        };   
        if(/(y+)/.test(fmt))   
            fmt=fmt.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length));   
        for(var k in o)   
            if(new RegExp("("+ k +")").test(fmt))   
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));   
        return fmt;   
    };
    // getQueryVariable 获取url参数
    Vue.prototype.getQueryVariable = function (variable) {
       var query = window.location.search.substring(1);
       var vars = query.split("&");
       for (var i=0;i<vars.length;i++) {
               var pair = vars[i].split("=");
               if(pair[0] == variable){return pair[1];}
       }
       return(false);
    };
    // 选项value转label
    Vue.prototype.valueConvertLabel = function (list,res) {
        let obj = {};
        list.forEach(item => {
            obj[item.code] = item.value
        });
        return obj[res];
    };
    // 选项label转value
    Vue.prototype.labeltConvertValue = function (list,res) {
        let obj = {};
        list.forEach(item => {
            obj[item.label] = item.value
        });
        return obj[res];
    };

};
